import { Fragment } from 'react';
import { ProductsQuantity } from '../../../../../../types/api/products/ProductsQuantity';

import formatQuantityLabel from '../../../../../../components/Treatment/helpers/formatQuantityLabel';
import formatPrice from '../../../../../../helpers/formatPrice';

import Typography from '../../../../../../components/_ui/_blocks/Typography/Typography';

interface Props {
    quantity: ProductsQuantity;
    isOutOfStock: boolean;
}

const Quantity = ({ quantity, isOutOfStock }: Props) => (
    <Fragment>
        <span className={isOutOfStock ? 'opacity-50' : undefined}>
            <span className="block">{formatQuantityLabel(quantity)}</span>
            <Typography className="block" size="080" color="quiet">
                {quantity.price_per || `${formatPrice(quantity.unit_cost)} per pack`}
            </Typography>
        </span>
        <span className="flex items-center gap-100 flex-shrink-0">
            {isOutOfStock
                ? <Typography size="090" weight="600" color="error-dark">Out of stock</Typography>
                : null}
            <Typography
                typeset="emphasis"
                size="200"
                color={isOutOfStock ? 'quiet' : 'price'}
                className={isOutOfStock ? 'opacity-50' : undefined}
            >
                {formatPrice(quantity.price)}
            </Typography>
        </span>
    </Fragment>
);

export default Quantity;
